import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { CallToActionBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { secondaryBlockDefaultStyles } from "../../constants";

export const meta: ComponentMeta = {
  name: "Homepage Block 9",
  nameI18n: "builder_ui.block_type.homepage.block_9",
  version: 1,
  category: [CallToActionBlock],
  props: {
    header: {
      name: "Header",
      nameI18n: "builder_ui.prop_type.header",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    buttons: {
      name: "Buttons",
      nameI18n: "builder_ui.prop_type.buttons",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    footer: {
      name: "Footer",
      nameI18n: "builder_ui.prop_type.footer",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles",
      prop: "styles",
      attributes: {
        backgroundColor: {
          ...backgroundColor,
          category: [DesignProp, GeneralProp],
          defaultValue: "var(--theme-website-color-6)",
        },
        backgroundImage: {
          ...backgroundImage,
          category: [DesignProp, GeneralProp],
        },
        padding: {
          ...padding,
          category: [DesignProp, PaddingsProp],
          defaultValue: secondaryBlockDefaultStyles.padding,
        },
        margin: {
          ...margin,
          category: [DesignProp, MarginsProp],
          defaultValue: secondaryBlockDefaultStyles.margin,
        },
      },
      type: "styles",
    },
  },
};
